import React, { useEffect } from "react";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/salesSaga";
import CustomDateRanges from "./smartComponents/customDateRanges";
import DatePicker from "./smartComponents/datePicker";
import NumberDisplay from "../../../components/moneyDisplay/moneyDisplay";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import PieChart from "../../../components/charts/pieChart/pieChart";
import { StaffSalesTable } from "./smartComponents/StaffSalesTable";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import "./staffSales.scss";

const StaffSales = (props) => {
  const initialRequest = useSelector((state) => state.staffSales.initialRequest);
  const isUpdating = useSelector((state) => state.staffSales.isUpdating);
  const dataPoints = useSelector((state) => state.staffSales.dataPoints);
  const isLoading = useSelector((state) => state.staffSales.isLoading);
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);
  const { revenuePieChart = [], revenueCategoriesPieChart = [] } = useSelector(
    (state) => state.staffSales.pieCharts
  );

  const formattedDataPoints = [dataPoints.slice(0, 3), dataPoints.slice(3)];

  const dispatch = useDispatch();

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchData(props));
    }
  }, []);

  const content = () => {
    return (
      <div id="staffSales">
        <div className="edit-selections-bar">
          <div className="select-box-no-width date-range-select-box">
            <p className="offers-title">Date Range</p>
            <CustomDateRanges />
          </div>

          <div className="date-select-box multi">
            <p className="offers-title">Date</p>
            <DatePicker />
          </div>

          <UpdateBtns />
        </div>

        {!isUpdating ? (
          <>
            <div className="data-points">
              {dataPoints &&
                formattedDataPoints.map((dataPoints, ind) => (
                  <div className="data-points__section" key={ind}>
                    {dataPoints.map((dataPoint) => (
                      <div key={dataPoint.label} className="data-points__elem">
                        <SectionContainer title={dataPoint.label}>
                          <NumberDisplay
                            value={dataPoint.value}
                            url={dataPoint.link ? dataPoint.link : ""}
                            disableAnimation={isUserQa}
                            decimal={dataPoint.decimal}
                          />
                        </SectionContainer>
                      </div>
                    ))}
                  </div>
                ))}
            </div>
            {revenuePieChart.length !== 0 && revenueCategoriesPieChart.length !== 0 ? (
              <div className="pie-chart">
                <div className="pie-chart__el">
                  <PieChart
                    data={revenuePieChart}
                    width={675}
                    height={300}
                    responsive={false}
                    showLegend
                    legendPosition="right"
                    showPercent
                  />
                </div>
                <div className="pie-chart__el">
                  <PieChart
                    data={revenueCategoriesPieChart}
                    width={675}
                    height={300}
                    addOtherLabel
                    isSortable
                    showLegend
                    legendPosition="right"
                    isLegendTooltip
                    showPercent
                    legendTooltipPosition="left"
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            <StaffSalesTable />
          </>
        ) : (
          <LoadingAnimation text="Updating data..." />
        )}
      </div>
    );
  };
  return (
    <SectionToggle
      isLoading={isLoading}
      title="Staff Sales and Conversions"
      content={content()}
      learnMore={
        <KBLearnMore
          title="Staff Sales and Conversions"
          description="This report shows employee sales activity and conversion outcomes based on logged staff interactions. These insights help you understand how effectively your team engages with clients and where additional training or support may be needed."
          kbUrl={ILEARN_URLS.staffActivity.staffSalesAndConversions}
        />
      }
    />
  );
};

export default React.memo(StaffSales);
